import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { dataSourceDetailActionTypes, dataSourceDetailLoadingAction, dataSourceDetailLoadedAction, } from '../ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import DataSourceResource from '../../../DataSource.resource';
import { ApiErrorType } from '@ane/core/lib/models';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { WorkspaceMigrationStatusCodes } from '@ane/core/lib/models/IAsyncWrapper/WorkspaceMigrationModels';
import { MigrationErrorMessages } from '@ane/core/lib/constants/WorkspaceMigration.constants';
const loadDataSourceArgs = {
    filterOnType: dataSourceDetailActionTypes.LOAD,
    skiploadDataTransform: true,
    loadResource: (payload, state) => {
        return DataSourceResource.getDataSource(payload.workspaceId, payload.dataSourceName);
    },
    loadingAction: dataSourceDetailLoadingAction,
    loadedAction: (successData, payload, error) => {
        let errorContext = undefined;
        if (EnvironmentService.wsplitEnableRedirects() && successData.statusCode === WorkspaceMigrationStatusCodes.MovedPermanently) {
            /**
             * Workspace migration
             * 301 will not return error error context
             */
            errorContext = {
                statusCode: successData.statusCode,
                displayError: MigrationErrorMessages.MovedPerminenty,
                type: ApiErrorType.MovedPermanently,
                correlationId: 'No correlationId provided',
            };
        }
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData.getSuccessData(),
            error: error,
            errorContext: errorContext,
        };
        return of(dataSourceDetailLoadedAction(payload, result));
    },
};
export const loadDataSourceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceArgs);
export default combineEpics(loadDataSourceEpic);

//# sourceMappingURL=DataSourceDetailEpic.js.map
